module.exports = "/images/us-hi.svg?3e005d8beec7867a9122f9e7aa1a8fda";